import React, { Component } from 'react'
import { graphql } from 'gatsby'
import ArticleMiniTeaser from '../ArticleMiniTeaser/index'

export default class MostReadBlogPosts extends Component {
  render() {
    const { data } = this.props
    return (
      <div className="pt-4">
        <h2 className="text-secondary">Most read blog posts</h2>
        <div className="mt-3">
          {data.edges.map(({ node }) => (
            <div className="" key={`mostread-${node.id}`}>
              <ArticleMiniTeaser data={node} />
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export const MostReadBlogPostsQuery = graphql`
  fragment mostRead on Query {
    mostRead: allMdx(
      filter: { frontmatter: { type: { eq: "blog" }, most_read: { eq: true } } }
      sort: { order: DESC, fields: frontmatter___date }
      limit: 3
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          excerpt
          frontmatter {
            title
            category
            cover_image {
              childImageSharp {
                fluid(maxWidth: 500, maxHeight: 300) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  }
`
